import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderComponent } from '../shared/util/loader/loader.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private _dialogRef: MatDialogRef<LoaderComponent>;

  constructor(
    private modal: MatDialog
  ) { }

  public show(message: string | Observable<string>) {

    const ref = this.modal.open(LoaderComponent, {
      panelClass: 'dialog-transparent',
      hasBackdrop: false,
      disableClose: true,
      data: { message }
    });
    this._dialogRef = ref;

    if (message instanceof Observable) {
      message.subscribe({
        complete: () => { ref.close(); }
      });
    }
    return this;
  }

  public close() {
    if (this._dialogRef) {
      this._dialogRef.close();
    }
  }

  public message(message: string) {
    this._dialogRef.componentInstance.update(message);
  }

}
